import { useEffect } from 'react'
import { CuiModal } from 'front-lib'
import { useAtom } from 'jotai'
import { userOnboardingModalAtom } from 'src/atoms/modals/userOnboardingModal.atom'
import { BasicsSection } from 'src/pages/coreUx/onboarding/components/BasicsSection'
import { track } from 'src/shared/tracking'
import { useOnboardingStatus } from 'src/hooks/useOnboardingStatus'

import './UserOnboardingModal.scss'

const trackingProps = {
  overlay_name: 'Onboarding RVMP - TODO list',
  overlay_class: 'modal',
  overlay_source: 'custom',
  overlay_trigger: 'manual'
}

export function UserOnboardingModal() {
  const { onboardingStatus } = useOnboardingStatus()
  const [{ isOpen }, setUserOnboardingModal] = useAtom(userOnboardingModalAtom)

  useEffect(() => {
    const onboardingCompletedSteps = onboardingStatus
      .filter(step => step.completed)
      .map(step => step.name)

    track('Overlay Viewed', {
      ...trackingProps,
      onboarding_status:
        onboardingCompletedSteps.length === onboardingStatus.length
          ? 'completed'
          : 'in_progress',
      onboarding_progress: onboardingCompletedSteps,
      overlay_action: 'open'
    })
  }, [onboardingStatus])

  function handleClose() {
    track('Overlay Closed', {
      ...trackingProps,
      overlay_action: 'close'
    })
    setUserOnboardingModal({ isOpen: false })
  }

  return (
    <CuiModal
      isOpen={isOpen}
      onRequestClose={handleClose}
      withCloseIcon
      data-testid="user-onboarding-modal"
      className="user-onboarding-modal">
      <div className="user-onboarding-modal__title">Next steps</div>
      <BasicsSection />
    </CuiModal>
  )
}
